import { filter, map } from 'rxjs/operators';

import { saveSpendIntent } from '../../../features/application/reducers/business-info';
import { nextStep } from '../../../features/application/reducers/next-step';
import { RootEpic } from '../index';

export const saveSpendIntentEpic: RootEpic = (action$) =>
  action$.pipe(
    filter(saveSpendIntent.match),
    map(() =>
      nextStep({
        action: 'collect_business_and_applicant_info',
        page: 'spend_intent',
        gotoNextPage: true,
      }),
    ),
  );
